import {
  keepPreviousData,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query'
import { isEmpty } from 'lodash-es'
import { useEffect, useState } from 'react'

import { mapQueries } from '@/entities/map'

export const useKeywordQuery = ({
  keyword,
  enabled,
}: {
  keyword: string
  enabled?: boolean
}) => {
  const queryClient = useQueryClient()

  const [loading, setLoading] = useState(false)

  const { isLoading, data } = useQuery({
    ...mapQueries.searchKeywordList({ keyword, maxSize: 30 }),
    staleTime: Infinity,
    enabled,
    placeholderData: keepPreviousData,
  })

  const keywords = enabled ? data : undefined

  const regions = keywords?.regions ?? []
  const subways = keywords?.subways ?? []
  const landmarks = keywords?.landmarks ?? []

  const hasRegions = !isEmpty(regions)
  const hasSubways = !isEmpty(subways)
  const hasLandmarks = !isEmpty(landmarks)

  const hasNoMarker = !(hasRegions || hasSubways || hasLandmarks)

  useEffect(() => {
    if (isLoading && !loading) {
      setLoading(true)

      setTimeout(() => {
        setLoading(false)
      }, 300)
    }
  }, [isLoading])

  useEffect(() => {
    return () => {
      queryClient.removeQueries({
        queryKey: mapQueries.searchKeywordLists(),
      })
    }
  }, [])

  return {
    loading: isLoading || loading,
    regions,
    subways,
    landmarks,
    hasRegions,
    hasSubways,
    hasLandmarks,
    hasNoMarker,
  }
}
